import {getRequestUrl, Request} from "../../request";
import { getURL } from "../../utils";

export const get_order_report = (data) => {
  return Request.get(getURL(`/api/corporation-pa/orders/order-report/`), data);
};

export const export_order_report = (data) => {
  return Request.rawGet(getRequestUrl(getURL(`/api/corporation-pa/orders/order-report/`), data))
}